var levelOfAWSUsage = {
	"Level of AWS usage": "AWS 用量等級",
	"Do not use AWS today": "目前不使用 AWS",
	"Evaluating/experimenting with AWS": "評估/試驗 AWS",
	"Run dev/test workloads on AWS": "在 AWS 上執行開發/測試工作負載",
	"Run a production workload on AWS": "在 AWS 上執行單一生產工作負載",
	"Run multiple production workloads on AWS": "在 AWS 上執行多個生產工作負載"
};

export { levelOfAWSUsage as default };
